/**
 * The gray "Office only" note under a quote or invoice line that sells a NEW
 * assembly (Corbin, 2026-10-28).
 *
 * The customer reads size + type only ("2\" Double Check Assembly") because we
 * may buy a different brand when we order. The office still needs the make and
 * model it quoted, so it shows here, small and gray, with what the customer
 * reads beside it. Lines about the customer's own device never get this note:
 * their make, model and serial print as written.
 */
import { Lock } from "lucide-react";

export interface OfficeAssembly {
    /** The words the customer reads for this line. */
    customerSees: string;
    /** The make / model the office quoted (price book item name), or null. */
    officeName: string | null;
}

export function OfficeOnlyAssemblyNote({ note }: { note?: OfficeAssembly | null }) {
    if (!note) return null;
    return (
        <span
            className="inline-flex flex-wrap items-center gap-x-1.5 text-[11px] leading-snug text-muted-foreground"
            data-testid="office-only-assembly"
            title="The customer never sees this note. Their quote and invoice show the size and type only."
        >
            <Lock className="h-3 w-3 shrink-0" aria-hidden />
            <span className="font-semibold">Office only</span>
            {note.officeName && <span>· {note.officeName}</span>}
            <span>· Customer sees: {note.customerSees}</span>
        </span>
    );
}
